import { render } from "./PwdManagement.vue?vue&type=template&id=37a1f2c3&scoped=true"
import script from "./PwdManagement.vue?vue&type=script&lang=js"
export * from "./PwdManagement.vue?vue&type=script&lang=js"

import "./PwdManagement.vue?vue&type=style&index=0&id=37a1f2c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a1f2c3"]])

export default __exports__